// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../../node_modules/postcss-loader/dist/cjs.js!../../../../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GNUKlPittnsC6fKFpSn9 {
    padding: 16px;
    border-bottom: 1px solid #E5E5E5;
}

.xK4622Su1X1OXfIH_Gxz {
    font-size: 16px;
    margin-top: 0;
}

.wALjfb_E_TMEefhhqoZd {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.wALjfb_E_TMEefhhqoZd .xK4622Su1X1OXfIH_Gxz {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 0;
}

.AK9rrcLHLOyPVUpPhhhq {
    margin: 0;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
    font-size: 12px;
}

.wALjfb_E_TMEefhhqoZd + .wALjfb_E_TMEefhhqoZd {
    margin-top: 8px;
}

.wor1fPZyZoEgl3uqRMoe {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
}

.wor1fPZyZoEgl3uqRMoe:hover {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-dark"]};
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/DashboardWallet/DashboardWalletSociety/DashboardWalletSocietyDocument/DashboardWalletSocietyDocument.module.css"],"names":[],"mappings":"AAGA;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,mDAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mDAAmB;AACvB;;AAEA;IACI,mDAAwB;AAC5B","sourcesContent":["@value colors: \"../../../../../components/library/style/colors.css\";\n@value color-purple, color-purple-dark, color-text-subtle from colors;\n\n.documents {\n    padding: 16px;\n    border-bottom: 1px solid #E5E5E5;\n}\n\n.title {\n    font-size: 16px;\n    margin-top: 0;\n}\n\n.document {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.document .title {\n    font-size: 16px;\n    font-weight: 500;\n    margin-bottom: 0;\n}\n\n.date {\n    margin: 0;\n    color: color-text-subtle;\n    font-size: 12px;\n}\n\n.document + .document {\n    margin-top: 8px;\n}\n\n.download {\n    color: color-purple;\n}\n\n.download:hover {\n    color: color-purple-dark;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../../../../components/library/style/colors.css"`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"color-purple-dark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-dark"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"documents": `GNUKlPittnsC6fKFpSn9`,
	"title": `xK4622Su1X1OXfIH_Gxz`,
	"document": `wALjfb_E_TMEefhhqoZd`,
	"date": `AK9rrcLHLOyPVUpPhhhq`,
	"download": `wor1fPZyZoEgl3uqRMoe`
};
export default ___CSS_LOADER_EXPORT___;
